const petcoColors = {
  black: '#000000',
  white: '#FFFFFF',
  grey: '#A9B5BA',
  greyLight1: '#F4F6F6',
  greyLight2: '#E9ECED',
  greyLight3: '#D4D9DC',
  greyLight4: '#C4CDD5',
  greyLighter1: '#f3f0f0',
  greyLighter2: '#cccccc',
  greyLighter3: '#F3F6F6',
  greyDark1: '#8E9DA2',
  greyDark2: '#666666',
  greyDark3: '#333333',
  greyDark4: '#656565',
  petcoBlue: '#001952',
  blue: '#0A598F',
  blueLight1: '#00AAE7',
  blueLight4: '#D9F1FB',
  blueDark1: '#0083B2',
  blueDark2: '#0B98FF',
  blueDaker1: '#1a2151',
  blueDarker2: '#19204f',
  blueDarker3: '#0b1531',
  petcoYellow: '#FFD305',
  yellow1: '#fed307',
  yellow2: '#e8bf1f',
  green: '#007500',
  greenLight1: '#E9FDf2',
  greenLight2: '#E9FDf2',
  greenLight3: '#E3F6DE',
  greenLight4: '#75F5B1',
  red: '#FB4341',
  redLight1: '#FCDFDD',
  redLight2: '#F7B0AA',
  redDark1: '#E02924',
  orange: '#FC951F',
  orangeLight1: '#FFFAF1',
  gradientLight: '#02D3F0',
  gradientDark: '#02A0E0',
};

export default petcoColors;
